"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineTitleSuffix = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineTitleSuffix = (item, order) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            return ``;
        }
        case "HOTEL": {
            return ``;
        }
        case "EXCURSION": {
            return ``;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            const passenger_name = config.where_when_who.pickup_name;
            if (passenger_name !==
                order?.client?.first_name + " " + order?.client?.last_name &&
                passenger_name &&
                passenger_name?.length > 0) {
                return `(${passenger_name})`;
            }
            else
                return "";
        }
        case "CUSTOM": {
            return "";
        }
    }
};
exports.getOrderLineTitleSuffix = getOrderLineTitleSuffix;
